/**
 * Przybliża widok mapy do zakresu wskazanej warstwy.
 */
const fitLayerView = (map, layer, fitBoundsParams = {}) =>
  map.fitBounds(layer.getBounds(), fitBoundsParams);

export default fitLayerView;
